import Reveal from "@/components/Reveal";
import { COMMUNITY } from "@/constants/testIds";
import { ASSETS } from "@/lib/config";

export default function Community() {
  return (
    <section
      id="community"
      data-testid={COMMUNITY.root}
      className="relative text-[#0a0a0a] overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, #1a3a44 0%, #c9d3d8 22%, #c9d3d8 78%, #14304a 100%)",
      }}
    >
      {/* Full-bleed magazine spread */}
      <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch">
        <div
          className="relative flex flex-col justify-center px-8 md:px-14 lg:px-24 py-24 md:py-32 lg:py-0 min-h-[600px] lg:min-h-0 grain"
        >
          <Reveal>
            <p className="font-serif text-[#0a0a0a]/25 text-6xl md:text-7xl leading-none mb-8">
              06.
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <p className="text-[11px] tracking-[0.42em] uppercase text-[#4a565c] mb-8">
              (06) — The Circle
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[1.02] tracking-tight max-w-[14ch]">
              You&rsquo;re part of<br />
              <span className="font-light text-[#14304a]">
                something bigger.
              </span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-10 text-[#1a2028] max-w-lg text-base md:text-lg leading-relaxed font-light">
              VISION is a growing circle of people committed to intentional
              living — thinkers, makers, movers, and quiet believers. Different
              paths, same north star.
            </p>
          </Reveal>
          <Reveal delay={0.28}>
            <p className="mt-10 font-serif text-2xl md:text-3xl leading-snug text-[#0a0a0a] max-w-md">
              Walk with people who see what you see.
            </p>
          </Reveal>
        </div>

        <div className="relative aspect-square lg:aspect-auto overflow-hidden">
          <img
            src={ASSETS.pierMorning}
            alt="Morning movement by the water"
            className="w-full h-full object-cover hidden lg:block fade-left"
            draggable={false}
            loading="lazy"
          />
          <img
            src={ASSETS.pierMorning}
            alt=""
            aria-hidden
            className="w-full h-full object-cover lg:hidden"
            draggable={false}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
